import push from '../../utils/routing';
import { getAssignmentsPath } from './routes';

export const goToAssignments =
  (
    spaceId: string,
    sectionId?: string | null,
    queryParams?: Record<string, string>,
    responsiveAssignmentsEnabled = false
  ) =>
  () => {
    let pathname = getAssignmentsPath(spaceId);

    const isMobileScreen = window.matchMedia('(max-width: 899px)').matches;

    if (responsiveAssignmentsEnabled && isMobileScreen) {
      pathname = `${pathname}/list`;
    }

    push({
      pathname,
      ...(queryParams ? { query: queryParams } : {}),
    });
  };
